import React, { FC, useEffect, useState } from 'react';

import WarningIcon from '../../assets/icons/warning';
import { checkUserSystem } from '../../utils/cryptoPro/checkUtils';

import './index.scss';

const FormFooter: FC<{ children?: React.ReactNode; skipCheck?: boolean }> = ({ children, skipCheck = false }) => {
  const [isSystemError, setIsSystemError] = useState(false);

  useEffect(() => {
    if (!skipCheck) {
      checkUserSystem().then((res) => setIsSystemError(!res));
    } else {
      setIsSystemError(false);
    }
  }, [skipCheck]);

  return (
    <div className="form-footer__container">
      {isSystemError ? (
        <div className="form-footer__attention-no">
          <WarningIcon />
          <p>
            <span>Внимание, нет плагина!</span> Для работы на Платформе требуется{' '}
            <a
              href="https://cpdn.cryptopro.ru/content/cades/plugin-installation-windows.html"
              target="_blank"
              rel="noreferrer"
            >
              усиленная цифровая подпись (УКЭП).
            </a>
          </p>
        </div>
      ) : (
        children
      )}
    </div>
  );
};

export default FormFooter;
